import { render, staticRenderFns } from "./MatriculasPorTipoDeEnsinoCard.vue?vue&type=template&id=00c4c7c8"
import script from "./MatriculasPorTipoDeEnsinoCard.vue?vue&type=script&lang=js"
export * from "./MatriculasPorTipoDeEnsinoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports